"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSelectionsReloadMapper = void 0;
var NumberSelectionsReloadMapper = /** @class */ (function () {
    function NumberSelectionsReloadMapper(data) {
        this.localData = data;
    }
    NumberSelectionsReloadMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return NumberSelectionsReloadMapper;
}());
exports.NumberSelectionsReloadMapper = NumberSelectionsReloadMapper;
//# sourceMappingURL=NumberSelectionsReloadMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/NumberSelectionsReloadMapper.js
// module id = 2055
// module chunks = 8